import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BackupStatus } from 'shared';

@Injectable()
export class BackupService {
  constructor(private http: HttpClient) {
  }

  getBackupStatus(): Observable<BackupStatus> {
    return this.http.get<BackupStatus>('/api/cron/backup-status');
  }
  createBackup(): Observable<void> {
    return this.http.post<void>('/api/cron/backup', {});
  }
}
